module.exports = __webpack_public_path__ + "img/delabook.d93c748a.webp";